import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { MddCheckbox, MddDialog, MddDialogButtons } from "../../../components";
import { IIdNamePair } from "../../../model";
import { IEditItem } from "../../../store/resConfig/types";
import { IApplicationState } from "../../../store";
import {
  calculateItems,
  handleCheckedChange
} from "../../../store/resConfig/selectors";

interface IProps {
  isOpen: boolean;
  items: IEditItem[];
  edit: IEditItem[];
  demographics: IIdNamePair[];
  onClose: (edits?: IEditItem[]) => void;
}

const AddDemographicDialogComponent = ({
  isOpen,
  onClose,
  edit: editProps,
  items,
  demographics
}: IProps) => {
  const [edits, setEdits] = useState<IEditItem[]>([]);
  const state = useMemo<IEditItem[]>(
    () =>
      isOpen
        ? calculateItems({
            edits,
            items,
            parents: demographics,
            childs: [],
            editState: editProps
          })
        : [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [edits, isOpen]
  );

  useEffect(() => {
    if (isOpen) {
      setEdits([...editProps.map(m => ({ ...m }))]);
    }
  }, [editProps, isOpen]);

  const handleChange = (item: IEditItem) => {
    setEdits(handleCheckedChange(item, edits));
  };

  return (
    <MddDialog
      dialogProps={{ open: isOpen, maxWidth: "sm", fullWidth: true }}
      dialogTitleProps={{
        title: "Add Demographic(s)"
      }}
      dialogContentProps={{ className: "mdd-res-draft--dialog" }}
      dialogContent={
        <ul>
          {state?.map(item => (
            <li key={item.name} className="mdd-res-draft--li">
              <MddCheckbox
                key={`checkbox-${item.id}`}
                lblText={item.name!}
                chkBoxProps={{
                  id: item.parentId,
                  checked: item.checked,
                  disabled: item.disabledOnModal,
                  onChange: () => handleChange(item)
                }}
              />
            </li>
          ))}
        </ul>
      }
      onCloseClick={() => {
        onClose();
      }}
      dialogActions={
        <MddDialogButtons
          saveButtonText="Add Demographic"
          saveButtonProps={{
            onClick: () => onClose(edits),
            disabled: !state.some(i => i.checked && !i.disabledOnModal)
          }}
          closeButtonProps={{ onClick: () => onClose() }}
        />
      }
      showCloseButton
    />
  );
};

export const AddDemographicDialog = connect(
  ({ resConfig }: IApplicationState) => ({
    items: resConfig.demographics.items!,
    demographics: resConfig.demographics.list!,
    edit: resConfig.demographics.edit
  })
)(AddDemographicDialogComponent);
